import React from "react";
import "./dashboard.css";
import DashboardItem from "../DevicesPage/DashboardItem.tsx";

 const Dashboard = ({onComponentClick}) =>{
    return(
        <div>
            <DashboardItem onComponentClick = {onComponentClick}/>
            {/* <DashboardItem />
            <DashboardItem /> */}
        </div>
    )
}

export default Dashboard;